import { jsx, jsxs } from 'react/jsx-runtime';
import { Button } from './button.js';
import { Card, CardContent } from './card.js';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '@radix-ui/react-progress';
import '../../contexts/AppContext.js';
import { AlertCircle, RefreshCw } from 'lucide-react';
import 'react';
import '../../lib/toast.js';
import './alert.js';
import '@radix-ui/react-avatar';
import './badge.js';
import 'react-day-picker';
import './chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import './radio-group.js';
import '@radix-ui/react-select';
import '@radix-ui/react-separator';
import './sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import 'react-router-dom';
import '../page-layout/FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

/**
 * Standard error state component for displaying errors with consistent styling
 */
function ErrorState({ icon, title = 'Something went wrong', error, description, action, className, showErrorDetails = false, }) {
    const getErrorMessage = (err) => {
        if (err instanceof Error)
            return err.message;
        if (typeof err === 'string')
            return err;
        return 'An unknown error occurred';
    };
    const errorMessage = error ? getErrorMessage(error) : description;
    return (jsx(Card, { className: cn('border-destructive/20 bg-destructive/5', className), children: jsxs(CardContent, { className: "flex flex-col items-center justify-center py-12 px-6 text-center", children: [jsx("div", { className: "w-16 h-16 mx-auto mb-4 rounded-full bg-destructive/10 flex items-center justify-center text-destructive", children: icon || jsx(AlertCircle, { size: 32 }) }), jsx("h3", { className: "text-lg font-semibold text-destructive mb-2", children: title }), errorMessage && jsx("p", { className: "text-muted-foreground mb-6 max-w-md", children: errorMessage }), showErrorDetails && error instanceof Error && error.stack && (jsxs("details", { className: "mb-6 text-left", children: [jsx("summary", { className: "cursor-pointer text-sm text-muted-foreground hover:text-foreground", children: "Show error details" }), jsx("pre", { className: "mt-2 p-3 bg-muted rounded-md text-xs overflow-auto max-w-md text-muted-foreground", children: error.stack })] })), action && (jsxs(Button, { onClick: action.onClick, variant: action.variant || 'outline', size: "sm", className: "min-w-24", children: [jsx(RefreshCw, { size: 14, className: "mr-2" }), action.label] }))] }) }));
}
/**
 * Simple error state for tables and lists without card wrapper
 */
function ErrorTableState({ icon, title = 'Failed to load data', error, description, className, showErrorDetails = false, }) {
    const getErrorMessage = (err) => {
        if (err instanceof Error)
            return err.message;
        if (typeof err === 'string')
            return err;
        return 'An unknown error occurred';
    };
    const errorMessage = error ? getErrorMessage(error) : description;
    return (jsxs("div", { className: cn('flex flex-col items-center justify-center py-12 px-6 text-center', className), children: [jsx("div", { className: "w-16 h-16 mx-auto mb-4 rounded-full bg-destructive/10 flex items-center justify-center text-destructive", children: icon || jsx(AlertCircle, { size: 28 }) }), jsx("h3", { className: "text-base font-medium text-destructive mb-2", children: title }), errorMessage && (jsx("p", { className: "text-sm text-muted-foreground max-w-sm mb-4", children: errorMessage })), showErrorDetails && error instanceof Error && error.stack && (jsxs("details", { className: "text-left", children: [jsx("summary", { className: "cursor-pointer text-sm text-muted-foreground hover:text-foreground", children: "Show error details" }), jsx("pre", { className: "mt-2 p-3 bg-muted rounded-md text-xs overflow-auto max-w-md text-muted-foreground", children: error.stack })] }))] }));
}

export { ErrorState, ErrorTableState };
//# sourceMappingURL=error-state.js.map
